<template>
    <div class="profile">
        <div class="container">
            <div class="row">
                <navigation></navigation>
                <div class="col-sm-4 col-md-7 col-lg-8 col-xl-9">
                    <div class="profile__page">
                        <div class="profile__page__inner">
                          <div  v-if="loading" class="text-center mt-5 d-flex justify-content-center">
                            <b-spinner

                                variant="primary"
                            ></b-spinner>
                          </div>
                            <router-view v-else></router-view>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-modal v-model="modal"
                 centered
                 hide-footer
                 hide-header
                 :no-close-on-esc="true"
                 :no-close-on-backdrop="true"
                 :no-enforce-focus="true"
                 title="Уведомление">
            <p>
                Прежде чем начать пользоваться аккаунтом необходимо подтвердить свой email.
            </p>

            <p>
                Для этого перейдите по ссылке, которую мы прислали на вашу почту {{ email }}
            </p>

            <div class="mt-3">
                <button class="btn btn-sm btn-green" @click="closeConfirmEmailModal()">
                    Выйти из аккаунта
                </button>
            </div>
        </b-modal>

        <b-modal v-model="paymentResultModal" class="payment-modal"
                 centered
                 hide-footer
                 hide-header
                 :no-close-on-esc="true"
                 :no-close-on-backdrop="true"
                 :no-enforce-focus="true"
                 title="Уведомление">
            <p v-if="paymentResult">
                Оплата прошла успешно.
            </p>

            <p v-if="!paymentResult">
                Во время оплаты возникли ошибки. Код ошибки: {{ paymentCode }}
            </p>

            <div class="mt-3">
                <button class="btn btn-sm btn-green" @click="closePaymentResultModal()">
                    Закрыть
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import Navigation from './profile/Navigation.vue';

    export default {
        name: 'profile',
        data() {
            return {
                modal: false,
                paymentResultModal: false,
                paymentResult: null,
                paymentCode: null,
                loading:false
            };
        },
        methods: {
            closeConfirmEmailModal() {
                this.$store.dispatch('logout');
            },
            closePaymentResultModal() {
                this.paymentResultModal = false;
                this.$router.push({
                    name: 'profile',
                });
            },
        },
        computed: {
            email(){
              return this.$store.getters.user ? this.$store.getters.user.email : null
            }
        },
        mounted() {
            this.loading = true
            this.$store.dispatch('getUserInfo',this.$store.getters.token).then(()=> this.loading = false)

            if (this.$route.query.success) {
                this.paymentResultModal = true;

                this.paymentResult =
                    this.$route.query.success === '1' ||
                    this.$route.query.success === 'true' ;

                this.paymentCode = this.$route.query.code || '-';
            }
        },
        components: {
            Navigation,
        }
    }
</script>
